import React from 'react';
import styled from 'styled-components';
import { useModal } from 'components/shared/hooks';
import { useFlags } from 'launchdarkly-react-client-sdk';

import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';
import ProjectPage from './ProjectPage';
import ProjectPageLegacy from './ProjectPageLegacy';
import { LD_DOCUMENTS_DOCUMENT_BUILDER } from 'constants/featureFlags';

type StyledModalProps = {
  isOpen: boolean;
  ariaHideApp: boolean;
  contentLabel: string;
  overlayClassName: string;
};

const StyledModal = styled(CCModal)<StyledModalProps>`
  max-width: 960px;
  width: 90%;
  height: 90vh;
`;

const ProjectPageModal = ({
  projectNodeId,
  pageId,
  pageDatabaseId,
}: {
  projectNodeId: string;
  pageId: string;
  pageDatabaseId: string;
}) => {
  const { hideModal } = useModal();
  const { [LD_DOCUMENTS_DOCUMENT_BUILDER]: documentBuilderEnabled } =
    useFlags();

  return (
    <StyledModal
      isOpen
      testId="project-page-modal"
      ariaHideApp={false}
      contentLabel="Project Page"
      overlayClassName="modal"
      onRequestClose={() => hideModal()}
      shouldCloseOnOverlayClick
      showCloseButton={false}
      bodyStyle={{
        margin: 0,
        padding: 0,
        borderTopRightRadius: 12,
        borderTopLeftRadius: 12,
      }}
    >
      {documentBuilderEnabled ? (
        <ProjectPage
          projectNodeId={projectNodeId}
          pageId={pageId}
          pageDatabaseId={pageDatabaseId}
          onDelete={() => hideModal()}
        />
      ) : (
        <ProjectPageLegacy
          projectNodeId={projectNodeId}
          pageId={pageId}
          pageDatabaseId={pageDatabaseId}
          onDelete={() => hideModal()}
        />
      )}
    </StyledModal>
  );
};

export default ProjectPageModal;
